import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PersonAccountIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm2 15h-4a3 3 0 00-2.995 2.824L7 19v.484A8.958 8.958 0 0012 21c1.85 0 3.57-.559 5.001-1.516L17 19a3 3 0 00-3-3zM12 3a9 9 0 00-6.86 14.826 5.001 5.001 0 014.633-3.82L10 14h4a5.002 5.002 0 014.861 3.825A8.965 8.965 0 0021 12a9 9 0 00-9-9zm0 2c2.201 0 4 1.735 4 3.893 0 2.158-1.799 3.893-4 3.893S8 11.05 8 8.893C8 6.735 9.799 5 12 5zm0 2c-1.113 0-2 .856-2 1.893s.887 1.893 2 1.893 2-.856 2-1.893S13.113 7 12 7z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
PersonAccountIcon.isCarinaIcon = true;
export default PersonAccountIcon;
